<template>
  <div class="App-Reset-Succ" txt-center>
    <div txt-center style="min-height: 60px; padding: 10px 20px">
      <el-image lazy :style="`width: 200px;`" :src="img"></el-image>
    </div>
    <h2 m-tb-0 txt-center>
      Email Verified <br />
      successfully!
    </h2>
    <p m-tb-0>Now you can sign in!</p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import img from "@/assets/illustrations/email-activation.svg";

// import CheckEmailImage
@Options({
  components: {},
})
export default class extends Vue {
  img = img;
}
</script>

<style lang="scss">
.App-Reset-Succ {
  .el-image {
    min-height: 20vh;
  }
}
</style>
